export default __webpack_public_path__ + "static/media/custodian.f667600b.jpg";